import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/esm/slicedToArray';
import _fillInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/fill';
import _trimInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/trim';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import { useState, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import Downshift from 'downshift';
import { defineMessages, useIntl } from 'react-intl';
import Constraints from '@commercetools-uikit/constraints';
import { filterDataAttributes } from '@commercetools-uikit/utils';
import { getToday, getDateInMonth, createItemToString, parseInputToDate, getIsDateInRange, createCalendarItems, getPaddingDayCount, getWeekdayNames, CalendarBody, getNextDay, getPreviousDay, getDaysInMonth, CalendarMenu, CalendarHeader, getMonthCalendarLabel, getYearCalendarLabel, CalendarContent, CalendarDay, isSameDay, getCalendarDayLabel, changeMonth } from '@commercetools-uikit/calendar-utils';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
var messages = defineMessages({
  placeholder: {
    id: 'UIKit.DateInput.placeholder',
    description: 'Placeholder for date input',
    defaultMessage: 'MM/DD/YYYY'
  }
});

function ownKeys(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context2;

      _forEachInstanceProperty(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var preventDownshiftDefault = function preventDownshiftDefault(event) {
  // eslint-disable-next-line no-param-reassign
  event.nativeEvent.preventDownshiftDefault = true;
};

var DateInput = function DateInput(props) {
  var intl = useIntl();

  var _useState = useState(props.value || getToday()),
      _useState2 = _slicedToArray(_useState, 2),
      calendarDate = _useState2[0],
      setCalendarDate = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      suggestedItems = _useState4[0],
      setSuggestedItems = _useState4[1];

  var _useState5 = useState(props.value === '' ? null : getDateInMonth(props.value) - 1),
      _useState6 = _slicedToArray(_useState5, 2),
      highlightedIndex = _useState6[0],
      setHighlightedIndex = _useState6[1];

  var inputRef = useRef();
  var onChange = props.onChange;
  var emit = useCallback(function (value) {
    return onChange({
      target: {
        id: props.id,
        name: props.name,
        // when cleared the value is null, but we always want it to be an
        // empty string when there is no value.
        value: value || ''
      }
    });
  }, [onChange, props.id, props.name]);
  var handleChange = useCallback(function (date) {
    inputRef.current.setSelectionRange(0, 100);
    emit(date);
  }, [inputRef, emit]);
  var onBlur = props.onBlur;
  var handleBlur = useCallback(function () {
    if (onBlur) onBlur({
      target: {
        id: props.id,
        name: props.name
      }
    });
  }, [onBlur, props.id, props.name]);

  var showToday = function showToday() {
    var today = getToday();
    setCalendarDate(today);
    setHighlightedIndex(suggestedItems.length + getDateInMonth(today) - 1);
    inputRef.current.focus();
  };

  var jumpMonth = function jumpMonth(amount) {
    var dayToHighlight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var nextDate = changeMonth(calendarDate, amount);
    setCalendarDate(nextDate);
    setHighlightedIndex(dayToHighlight);
  };

  return jsx(Constraints.Horizontal, {
    max: props.horizontalConstraint,
    children: jsx(Downshift, {
      inputId: props.id,
      itemToString: createItemToString(intl.locale),
      selectedItem: props.value === '' ? null : props.value,
      highlightedIndex: highlightedIndex,
      onChange: handleChange,
      onStateChange: function onStateChange(changes) {
        /* eslint-disable no-prototype-builtins */
        if (changes.hasOwnProperty('inputValue')) {
          // input changed because user typed
          if (changes.type === Downshift.stateChangeTypes.changeInput) {
            var date = parseInputToDate(changes.inputValue, intl.locale);

            if (date === '') {
              setSuggestedItems([]);
              setHighlightedIndex(null);
            } else {
              setSuggestedItems([date]);

              if (getIsDateInRange(date, props.minValue, props.maxValue)) {
                setHighlightedIndex(getDateInMonth(date) - 1);
              }

              setCalendarDate(date);
            }
          } else {
            // input changed because user selected a date
            setSuggestedItems([]);
            setHighlightedIndex(null);
          }
        }

        if (changes.hasOwnProperty('highlightedIndex')) {
          setHighlightedIndex(changes.highlightedIndex);
        }
        /* eslint-enable no-prototype-builtins */

      },
      children: function children(_ref) {
        var _context;

        var getInputProps = _ref.getInputProps,
            getMenuProps = _ref.getMenuProps,
            getItemProps = _ref.getItemProps,
            getToggleButtonProps = _ref.getToggleButtonProps,
            clearSelection = _ref.clearSelection,
            downshiftHighlightedIndex = _ref.highlightedIndex,
            openMenu = _ref.openMenu,
            setDownshiftHighlightedIndex = _ref.setHighlightedIndex,
            selectedItem = _ref.selectedItem,
            isOpen = _ref.isOpen,
            inputValue = _ref.inputValue;
        var calendarItems = createCalendarItems(calendarDate, intl);
        var paddingDayCount = getPaddingDayCount(calendarDate, intl.locale);

        var paddingDays = _fillInstanceProperty(_context = Array(paddingDayCount)).call(_context);

        var weekdays = getWeekdayNames(intl.locale);
        var today = getToday();
        return jsxs("div", {
          onFocus: props.onFocus,
          onBlur: handleBlur,
          children: [jsx(CalendarBody, {
            inputRef: inputRef,
            inputProps: getInputProps(_objectSpread({
              // Unset the aria-labelledby as it interfers with the link
              // between the <label for> and the <input id>.
              'aria-labelledby': undefined,
              name: props.name,
              placeholder: typeof props.placeholder === 'string' ? props.placeholder : intl.formatMessage(messages.placeholder),
              onMouseEnter: function onMouseEnter() {
                // we remove the highlight so that the user can use the
                // arrow keys to move the cursor when hovering
                if (isOpen) setDownshiftHighlightedIndex(null);
              },
              onKeyDown: function onKeyDown(event) {
                if (props.isReadOnly) {
                  preventDownshiftDefault(event);
                  return;
                }

                if (event.key === 'Enter' && _trimInstanceProperty(inputValue).call(inputValue) === '') {
                  clearSelection();
                } // ArrowDown


                if (event.keyCode === 40) {
                  var nextDayToHighlight = getNextDay(calendarItems[highlightedIndex]);

                  if (!getIsDateInRange(nextDayToHighlight, props.minValue, props.maxValue)) {
                    // if the date to highlight is disabled
                    // then do nothing
                    preventDownshiftDefault(event);
                    return;
                  }

                  if (highlightedIndex + 1 >= calendarItems.length) {
                    // if it's the end of the month
                    // then bypass normal arrow navigation
                    preventDownshiftDefault(event); // then jump to start of next month

                    jumpMonth(1, 0);
                  }
                } // ArrowUp


                if (event.keyCode === 38) {
                  var previousDay = getPreviousDay(calendarItems[highlightedIndex]);

                  if (!getIsDateInRange(previousDay, props.minValue, props.maxValue)) {
                    // if the date to highlight is disabled
                    // then do nothing
                    preventDownshiftDefault(event);
                    return;
                  }

                  if (highlightedIndex <= 0) {
                    // if it's the start of the month
                    // then bypass normal arrow navigation
                    preventDownshiftDefault(event);
                    var numberOfDaysOfPrevMonth = getDaysInMonth(previousDay); // then jump to the last day of the previous month

                    jumpMonth(-1, numberOfDaysOfPrevMonth - 1);
                  }
                }
              },
              // we only do this for readOnly because the input
              // doesn't ignore these events, unlike when its disabled
              onClick: props.isReadOnly ? undefined : openMenu
            }, filterDataAttributes(props))),
            hasSelection: Boolean(selectedItem),
            onClear: clearSelection,
            isOpen: isOpen,
            isDisabled: props.isDisabled,
            isReadOnly: props.isReadOnly,
            toggleButtonProps: getToggleButtonProps(),
            hasError: props.hasError,
            hasWarning: props.hasWarning
          }), isOpen && !props.isDisabled && !props.isReadOnly && jsxs(CalendarMenu, _objectSpread(_objectSpread({}, getMenuProps()), {}, {
            hasError: props.hasError,
            hasWarning: props.hasWarning,
            children: [jsx(CalendarHeader, {
              monthLabel: getMonthCalendarLabel(calendarDate, intl.locale),
              yearLabel: getYearCalendarLabel(calendarDate, intl.locale),
              onPrevMonthClick: function onPrevMonthClick() {
                return jumpMonth(-1);
              },
              onTodayClick: showToday,
              onNextMonthClick: function onNextMonthClick() {
                return jumpMonth(1);
              },
              onPrevYearClick: function onPrevYearClick() {
                return jumpMonth(-12);
              },
              onNextYearClick: function onNextYearClick() {
                return jumpMonth(12);
              }
            }), jsxs(CalendarContent, {
              children: [_mapInstanceProperty(weekdays).call(weekdays, function (weekday) {
                return jsx(CalendarDay, {
                  type: "heading",
                  children: weekday
                }, weekday);
              }), _mapInstanceProperty(paddingDays).call(paddingDays, function (day, index) {
                return jsx(CalendarDay, {
                  type: "spacing"
                }, index);
              }), _mapInstanceProperty(calendarItems).call(calendarItems, function (item, index) {
                return jsx(CalendarDay, _objectSpread(_objectSpread({
                  isToday: isSameDay(today, item)
                }, getItemProps({
                  disabled: !getIsDateInRange(item, props.minValue, props.maxValue),
                  item: item,
                  onMouseOut: function onMouseOut() {
                    setDownshiftHighlightedIndex(null);
                  }
                })), {}, {
                  isHighlighted: index === downshiftHighlightedIndex,
                  isSelected: isSameDay(item, props.value),
                  children: getCalendarDayLabel(item)
                }), item);
              })]
            })]
          }))]
        });
      }
    }, intl.locale)
  });
};

DateInput.displayName = 'DateInput';

DateInput.isEmpty = function (value) {
  return value === '';
};

DateInput.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Horizontal size limit of the input field.
   */
  horizontalConstraint: PropTypes.oneOf([6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 'scale', 'auto']),

  /**
   * The selected date, must either be an empty string or a date formatted as "YYYY-MM-DD".
   */
  value: PropTypes.string.isRequired,

  /**
   * Called when the date changes. Called with an event containing either an empty string (no value) or a string in this format: "YYYY-MM-DD".
   * <br />
   * Signature: `(event) => void`
   */
  onChange: PropTypes.func.isRequired,

  /**
   * Called when the date input gains focus.
   */
  onFocus: PropTypes.func,

  /**
   * Called when the date input loses focus.
   */
  onBlur: PropTypes.func,

  /**
   * Used as the HTML `id` attribute.
   */
  id: PropTypes.string,

  /**
   * Used as the HTML `name` attribute.
   */
  name: PropTypes.string,

  /**
   * Placeholder value to show in the input field
   */
  placeholder: PropTypes.string,

  /**
   * Disables the date picker
   */
  isDisabled: PropTypes.bool,

  /**
   * Disables the date picker menu and makes input field read-only
   */
  isReadOnly: PropTypes.bool,

  /**
   * Indicates the input field has an error
   */
  hasError: PropTypes.bool,

  /**
   * Indicates the input field has a warning
   */
  hasWarning: PropTypes.bool,

  /**
   * A minimum selectable date. Must either be an empty string or a date formatted as "YYYY-MM-DD".
   */
  minValue: PropTypes.string,

  /**
   * A maximum selectable date. Must either be an empty string or a date formatted as "YYYY-MM-DD".
   */
  maxValue: PropTypes.string
} : {};
var DateInput$1 = DateInput; // NOTE: This string will be replaced on build time with the package version.

var version = "12.2.9";
export { DateInput$1 as default, version };